import React, { forwardRef } from 'react';
import { TextVariant } from '@naf/text';
import MemberLabel from '@components/MemberLabel/MemberLabel';
import { useDocumentUrlWithNode } from '../../../hooks/Documents/useDocumentUrl';
import { CloudinaryImageType } from '../../../../../types/CloudinaryImageType';
import { useCloudinary } from '../../../hooks/Cloudinary/useCloudinary';
import * as S from './Styles';

type Props = {
  article: {
    id: string;
    name: string;
    ingress: string;
    slug: string;
    isActive: boolean;
    image: CloudinaryImageType;
    step: number;
    paywallDetails?: {
      isAccessibleForUser?: boolean;
      labelText?: string;
    };
  };
  size?: 'small' | 'large';
  showBorder?: boolean;
  layout?: 'horizontal' | 'vertical';
};

const ArticleSeriesItem = forwardRef<HTMLAnchorElement, Props>(
  ({ article, size = 'small', showBorder = false, layout = 'horizontal' }, ref) => {
    const { getResponsiveImage } = useCloudinary();
    const link = useDocumentUrlWithNode(article);

    const cldImage = getResponsiveImage(article.image?.publicId, {
      quality: 'auto:low',
      focusMethod: article.image?.focus,
      width: size === 'small' ? 200 : 250,
      height: size === 'small' ? 133 : 167,
    });

    return (
      <S.Wrapper $isActive={article.isActive} $showBorder={showBorder} $layout={layout} ref={ref} to={link}>
        <S.ImgAndLabel>
          {article.isActive && <S.StyledLabel text="Du leser nå" color="secondary" />}
          <S.StyledImg src={cldImage?.toURL() || ''} alt={article.image?.alt || article.image?.altText} $size={size} />
          {article.paywallDetails && (
            <MemberLabel
              labelText={article?.paywallDetails?.labelText || 'For medlemmer'}
              isEligible={article?.paywallDetails?.isAccessibleForUser}
            />
          )}
        </S.ImgAndLabel>
        <S.TextWrapper>
          <S.StyledText variant={TextVariant.ArticleTextHeader}>{`Del ${article.step}: ${article.name}`}</S.StyledText>
          {size === 'large' && <S.Ingress>{article.ingress}</S.Ingress>}
        </S.TextWrapper>
      </S.Wrapper>
    );
  },
);

export default ArticleSeriesItem;
